import type { ExportFilter } from '@casetrace/export';
import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

export interface TopBarCaseMenuActions {
  readonly caseId: string;
  readonly saksnummer: string;
  readonly filter: ExportFilter;
  readonly onOpenSources: () => void;
  readonly onOpenMembers: () => void;
}

interface TopBarMenuContextValue {
  readonly caseMenuActions: TopBarCaseMenuActions | null;
  readonly setCaseMenuActions: (actions: TopBarCaseMenuActions | null) => void;
}

const TopBarMenuContext = createContext<TopBarMenuContextValue | null>(null);

export function TopBarMenuProvider({ children }: { readonly children: ReactNode }) {
  const [caseMenuActions, setCaseMenuActions] = useState<TopBarCaseMenuActions | null>(null);

  const value = useMemo(
    () => ({ caseMenuActions, setCaseMenuActions }),
    [caseMenuActions, setCaseMenuActions],
  );

  return <TopBarMenuContext.Provider value={value}>{children}</TopBarMenuContext.Provider>;
}

export function useTopBarMenu() {
  const context = useContext(TopBarMenuContext);
  if (!context) {
    throw new Error('useTopBarMenu må brukes innenfor TopBarMenuProvider');
  }
  return context;
}
